import Auth from '@aws-amplify/auth'
import LocalDataUtil from '@/utils/LocalDataUtil'
import moment from 'moment'

export default class CognitoClient {
  static signIn (userId, password) {
    return Auth.signIn({
      username: userId,
      password: password
    }).catch(err => {
      if (err.code === 'UserNotFoundException') {
        alert('ユーザーが存在しません')
      } else if (err.code === 'NotAuthorizedException') {
        alert('ログイン情報が誤っています')
      }
    })
  }

  static signOut () {
    return Auth.signOut()
  }

  static signUp (username, password, name) {
    return Auth.signUp({
      username,
      password,
      attributes: {
        nickname: name
      }
    })
  }

  static getCurrentSession () {
    return Auth.currentSession()
  }

  static getCurrentCredentials () {
    return Auth.currentCredentials()
  }

  static getRefreshToken () {
    return Auth.currentSession().then((data) => {
      return data.refreshToken.token
    })
  }

  static checkAccessToken () {
    // Auth.currentSession().then(data => console.log(data))
    const accessToken = LocalDataUtil.getToken()
    if (accessToken) {
      if (this.decordJwtToken(accessToken).exp > moment().unix()) {
        return Promise.resolve(false)
      }
    }
    return Auth.signOut().then(onSuccess => {
      localStorage.clear()
      return true
    })
  }

  static decordJwtToken (jwtToken) {
    var base64Url = jwtToken.split('.')[1]
    var base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
  }
}
